// @flow
import * as React from 'react';
import ReactSelect from 'react-select';
import ReactVirtualizedSelect from 'react-virtualized-select';
import './Select.scss';

export type SelectProps = {
  clearable?: boolean,
  multi?: boolean,
  options: Array<*>,
  value?: *,
  disabled?: boolean,
  onChange: (*) => void | ((Array<*>) => void),
};

const Select = (props: SelectProps) => {
  const clearable = props.multi && props.multi === true;

  return <ReactSelect clearable={clearable} {...props} />;
};

const VirtualizedSelect = (props: SelectProps) => {
  const clearable = props.multi && props.multi === true;

  return <ReactVirtualizedSelect clearable={clearable} {...props} />;
};

Select.Virtualized = VirtualizedSelect;

export default Select;



// WEBPACK FOOTER //
// ./src/components/Common/Select.js